import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueHierarchyRedirectRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-hierarchy-redirect',
	path: '/secure/PortfolioHierarchy.jspa',
};
